import graphql__5790e8b14ea70200777d from "./__generated__/MapFilterUserFieldSelect_userField.graphql.js";import { useCallback, useRef } from "react";
import { graphql, useFragment } from "react-relay";
import { useSelector, useDispatch } from "react-redux";
import { defineMessages } from "react-intl";
import { uniqueId } from "lodash";

import Select from "../../../Select/Select";
import { useFormatMessage } from "../../../Intl/Context";

import { updateUserFieldFilter } from "../../../../reducers/map/filters";
import { useMapContext } from "../../MapContext";

const MapFilterUserFieldSelect = props => {
  const userField = useFragment(MapFilterUserFieldSelect_userField, props.userField);
  const { name, id: userFieldId } = userField;

  const { mapKey } = useMapContext();

  const selectedValue = useSelector(
    ({ map }) => map[mapKey].filters.activeUserFields[userFieldId] || []
  );

  const options = userField.options.map(option => ({
    value: option.id,
    label: option.name
  }));

  const selectedOptions = selectedValue.map(value =>
    options.find(option => option.value === value)
  );

  const dispatch = useDispatch();

  const handleChange = useCallback(
    options => {
      const values = options.map(option => option.value);
      dispatch(updateUserFieldFilter(mapKey, userFieldId, values));
    },
    [dispatch, mapKey, userFieldId]
  );

  const t = useFormatMessage();
  const placeholderText = t(intlMessages.placeholderText);

  const inputIdRef = useRef(uniqueId("map-filter-user-select-"));
  const inputId = inputIdRef.current;

  return (
    <div className="map-filter-user-field-select d-flex align-items-center">
      <label
        htmlFor={inputId}
        className="map-filter-user-field-select-label margin-right-sm font-weight-bold flex-1 margin-bottom-none"
      >
        {name}
      </label>

      <div className="map-filter-user-field-select-input flex-2">
        <Select
          inputId={inputId}
          className="react-select"
          classNamePrefix="react-select"
          defaultValue={selectedOptions}
          options={options}
          onChange={handleChange}
          placeholder={placeholderText}
          isMulti
          openMenuOnFocus
        />
      </div>
    </div>
  );
};

const MapFilterUserFieldSelect_userField = graphql__5790e8b14ea70200777d;

export default MapFilterUserFieldSelect;

const intlMessages = defineMessages({
  placeholderText: {
    id: "map.filters.userField.select.placeholderText",
    defaultMessage: "Sélectionnez ..."
  }
});
